import { SvgComponentProps } from "@/src/types/SVGPropType"
import * as React from "react"
const MetaPremiumSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="m.539 7.105.021.006a7.639 7.639 0 0 1 5.98 5.959c0 .003.003.008.004.011v.003c.098.373.191.386.29.04a7.636 7.636 0 0 1 5.976-6.009l.003-.001c.38-.1.387-.194.018-.295A7.637 7.637 0 0 1 6.835.81V.807C6.74.477 6.65.479 6.557.81l-.005.02-.023.089-.001.004-.032.146-.003.013A7.638 7.638 0 0 1 .877 6.75c-.002 0-.005 0-.008.002a5.46 5.46 0 0 1-.274.06H.593l-.01.003-.004.001c-.373.098-.386.19-.04.288v.002Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={2.676}
        x2={13.068}
        y1={16.009}
        y2={4.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.144} stopColor="#FFE9FE" />
        <stop offset={1} stopColor="#FF96F9" />
      </linearGradient>
    </defs>
  </svg>
)
export default MetaPremiumSVG
